<template>
    <div class="CommissionSettlementDetails">
        <div class="CommissionSettlementDetails-content">
            <div class="margin-top1" style="overflow: hidden;">
                <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
                    <!-- <el-form-item label="状态" prop="type">
                        <el-select v-model="ruleForm.type" placeholder="选择状态">
                            <el-option
                                v-for="(item,index) in staff"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item> -->

                    <el-form-item label="月份" prop="type">
                        <el-select v-model="ruleForm.salaryMonth" placeholder="选择月份">
                            <el-option v-for="(item,index) in month" :key="index" :label="item.name"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="开始日期" prop="starttime">
                        <el-date-picker style="width:210px;" v-model="ruleForm.starttime" type="datetime"
                            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始日期"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="结束日期" prop="endtime">
                        <el-date-picker style="width:210px;" v-model="ruleForm.endtime" type="datetime"
                            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束日期"></el-date-picker>
                    </el-form-item>

                    <el-form-item prop="type" style="width: 20%;" class="searchInput">
                        <!-- <el-input v-model="ruleForm.input" placeholder="用户名" style="width: 50%;"></el-input> -->
                        <el-button type="primary" style="margin-left: 15px;" class="search"
                            @click="searchForm">搜索</el-button>
                        <el-button type="primary" class="search" @click="searchReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div>
                <!-- <el-button type="primary" @click="open">薪资结算</el-button> -->
            </div>

            <div style="margin-top:15px;">
                <!-- <table border="0" cellpadding="0" width="100%" class="table-box">
                <thead>
                  <tr>
                    <td colspan="12" class="RoteName">今日汇率</td>
                  </tr>
                </thead>
                  <tbody>
                    <tr>
                      <th v-for="item in RateList">{{item.country}}</th>
                    </tr>
                    <tr>
                      <td v-for="item in RateList">{{item.exchangeRate}}</td>
                    </tr>
                  </tbody>
              </table> -->

                <el-table :data="tableData" border style="width: 100%;margin-top:20px;font-size:13px;"
                    v-loading="loading">
                    <el-table-column prop="userName" label="用户名" align="center"></el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state == 0">删除</span>
                            <span v-if="scope.row.state == 1">未提交</span>
                            <span v-if="scope.row.state == 2">未审核</span>
                            <span v-if="scope.row.state == 3">已发放</span>
                            <span v-if="scope.row.state == 4">审核失败</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="50" prop="salaryMonth" label="薪资月份" align="center"></el-table-column>
                    <el-table-column width="105" prop="cycle" label="提成结算周期" align="center"></el-table-column>
                    <el-table-column width="104" prop="settlementDate" label="结算日期" align="center"></el-table-column>

                    <el-table-column label="底薪" align="center">
                        <el-table-column prop="basicWage" label="基本工资" align="center"></el-table-column>
                        <el-table-column prop="seniorityPay" label="工龄工资" align="center"></el-table-column>
                        <el-table-column prop="financialReimbursement" label="岗位工资" align="center"></el-table-column>
                        <el-table-column prop="incentiveBonus" label="学历津贴" align="center"></el-table-column>
                    </el-table-column>

                    <el-table-column prop="supervisorCommission" label="提成" align="center"></el-table-column>
                    <el-table-column prop="groupCommission" label="小组提成" align="center"></el-table-column>

                    <el-table-column label="补助" align="center">
                        <el-table-column prop="trialPeriodAllowance" label="试岗补助" align="center"></el-table-column>
                        <el-table-column prop="trainingAllowance" label="培训补助" align="center"></el-table-column>
                        <el-table-column prop="tub" label="TUB" align="center"></el-table-column>
                        <el-table-column prop="otherAllowances" label="其他补助" align="center"></el-table-column>
                    </el-table-column>

                    <el-table-column prop="perfectAttendanceAward" label="全勤奖" align="center"></el-table-column>
                    <el-table-column prop="otherSubsidies" label="奖励" align="center"></el-table-column>
                    <el-table-column prop="reissue" label="补发" align="center"></el-table-column>
                    <el-table-column prop="payable" label="应发工资" align="center"></el-table-column>
                    <el-table-column prop="operationalDeduction" label="运营扣款" align="center"></el-table-column>
                    <el-table-column prop="attendanceDeduction" label="考勤扣款" align="center"></el-table-column>
                    <el-table-column prop="otherDeduction" label="职工保险代缴扣款" align="center"
                        width="130"></el-table-column>
                    <el-table-column prop="paidWage" label="实发工资" align="center" fixed="right"></el-table-column>
                    <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="Edit(scope.row)"><i class="el-icon-edit"></i></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog title="薪资结算" :visible.sync="settlement_steps1" width="50%">
                <div>
                    <label>选择月份：</label>
                    <el-select v-model="Setform.salaryMonth" placeholder="选择月份">
                        <el-option v-for="(item,index) in month" :key="index" :label="item.name"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
                <div style="margin-top:15px;">
                    <label>选择用户：</label>
                    <el-select v-model="Setform.user" placeholder="选择用户">
                        <el-option v-for="(item,index) in userList" :key="index" :label="item.userName"
                            :value="item.uid"></el-option>
                    </el-select>
                </div>
                <div style="margin-top:15px;">
                    提成结算时间
                </div>
                <div style="margin-top:15px;">
                    <label>开始时间：</label>
                    <el-date-picker style="width:210px;" v-model="Setform.starttime" type="datetime"
                        :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择开始日期"></el-date-picker>

                    <label style="margin-left:20px;">结束时间：</label>
                    <el-date-picker style="width:210px;" v-model="Setform.endtime" type="datetime"
                        :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择结束日期"></el-date-picker>
                </div>
                <div style="margin-top:15px;">
                    <label>结算日期</label>
                    <el-input style="width:100px;margin:10px;" v-model="Setform.settlementTime"></el-input>
                    <span>日</span>
                </div>
                <div style="margin-top:15px;">
                    <table border="0" cellpadding="0" width="100%" class="table-box">
                        <!-- <thead>
                        <tr>
                            <td colspan="12" class="RoteName">今日汇率</td>
                        </tr>
                        </thead> -->
                        <tbody>
                            <tr>
                                <th v-for="item in RateList1">{{item.country}}</th>
                            </tr>
                            <tr>
                                <td v-for="item in RateList1">
                                    <el-input v-model="item.exchangeRate"></el-input>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="settlement_steps1 = false">取 消</el-button>
                    <el-button type="primary" @click="Add">确 定</el-button>
                </span>
            </el-dialog>

            <el-dialog title="薪资结算" :visible.sync="settlement_steps2" width="50%">
                <div>
                    <span>用户名：{{contentList.userName}}</span>
                    <span style="margin-left:40px;">薪资月份：{{contentList.month}}</span>
                    <span style="margin-left:40px;">提成结算时间：{{contentList.cycle}}</span>
                </div>
                <div style="margin-top:15px;">
                    <el-table :data="contentList.sellerList" border style="width: 100%">
                        <el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
                        <el-table-column align="center" prop="shop_name" label="店铺名"></el-table-column>
                        <el-table-column align="center" prop="totalProfit" label="利润"></el-table-column>
                        <el-table-column align="center" prop="openRefund" label="未结退款"></el-table-column>
                        <el-table-column align="center" prop="finalProfit" label="最终利润"></el-table-column>
                    </el-table>
                </div>

                <div style="margin-top:15px;">
                    <label>结算提成：</label>
                    <el-input style="width:100px;margin:10px;" v-model="wage.commission"></el-input>
                </div>

                <div style="margin-top:15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" class="table-box wage-table">
                        <tbody>
                            <tr>
                                <template v-for="(h, index) in wageFields">
                                    <th v-if="h.children" :key="'group-' + index" :colspan="h.children.length"
                                        class="group-th">{{ h.label }}</th>
                                    <th v-else :key="'single-' + index" rowspan="2" class="single-th">{{ h.label }}</th>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(h, index) in wageFields">
                                    <template v-if="h.children">
                                        <th v-for="child in h.children" :key="child.prop" class="child-th">{{
                                            child.label }}</th>
                                    </template>
                                </template>
                            </tr>
                            <tr class="input-row">
                                <template v-for="(h, index) in wageFields">
                                    <template v-if="h.children">
                                        <td v-for="child in h.children" :key="child.prop">
                                            <el-input v-model="wage[child.prop]" size="small"
                                                @focus="setActiveField(child.prop)"></el-input>
                                        </td>
                                    </template>
                                    <td v-else :key="'td-' + h.prop">
                                        <el-input v-model="wage[h.prop]" size="small"
                                            @focus="setActiveField(h.prop)"></el-input>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style="margin-top:15px;">
                    <label style="line-height:50px;">备注</label>
                    <el-input type="textarea" :rows="3" v-model="wage.remarks"></el-input>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="Save">保存</el-button>
                </span>
            </el-dialog>


            <el-dialog title="薪资结算" :visible.sync="settlement_edit" width="50%">
                <div>
                    <span>用户名：{{valData.userName}}</span>
                    <span style="margin-left:40px;">薪资月份：{{valData.salaryMonth}}</span>
                    <span style="margin-left:40px;">提成结算时间：{{valData.cycle}}</span>
                </div>
                <!-- <div style="margin-top:15px;">
                    <el-table :data="valData.userProfitList" border style="width: 100%">
                        <el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
                        <el-table-column align="center" prop="sellerName" label="店铺名"></el-table-column>
                        <el-table-column align="center" prop="totalProfit" label="利润"></el-table-column>
                        <el-table-column align="center" prop="openRefund" label="未结退款"></el-table-column>
                        <el-table-column align="center" prop="finalProfit" label="最终利润"></el-table-column>
                    </el-table>
                </div> -->

                <div style="margin-top:15px;">
                    <label>结算提成：</label>
                    <el-input style="width:100px;margin:10px;" v-model="wage1.commission"></el-input>
                </div>

                <div style="margin-top:15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" class="table-box wage-table">
                        <tbody>
                            <tr>
                                <template v-for="(h, index) in wageFields">
                                    <th v-if="h.children" :key="'group-' + index" :colspan="h.children.length"
                                        class="group-th">{{ h.label }}</th>
                                    <th v-else :key="'single-' + index" rowspan="2" class="single-th">{{ h.label }}</th>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(h, index) in wageFields">
                                    <template v-if="h.children">
                                        <th v-for="child in h.children" :key="child.prop" class="child-th">{{
                                            child.label }}</th>
                                    </template>
                                </template>
                            </tr>
                            <tr class="input-row">
                                <template v-for="(h, index) in wageFields">
                                    <template v-if="h.children">
                                        <td v-for="child in h.children" :key="child.prop">
                                            <el-input v-model="wage1[child.prop]" size="small"
                                                @focus="setActiveField1(child.prop)"></el-input>
                                        </td>
                                    </template>
                                    <td v-else :key="'td-' + h.prop">
                                        <el-input v-model="wage1[h.prop]" size="small"
                                            @focus="setActiveField1(h.prop)"></el-input>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style="margin-top:15px;">
                    <label style="line-height:50px;">备注</label>
                    <el-input type="textarea" :rows="3" v-model="wage1.remarks"></el-input>
                </div>

                <div style="margin-top:15px">
                    <el-table :data="listTable" border style="margin-top:15px">
                        <el-table-column prop="sellerName" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="orderProfit" label="订单利润" align="center"></el-table-column>
                        <el-table-column prop="shopRent" label="店铺租金" align="center"></el-table-column>
                        <el-table-column prop="orderReturnFee" label="订单退款费用" align="center"></el-table-column>
                        <el-table-column prop="redeliveryFee" label="广告费用" align="center"></el-table-column>
                        <el-table-column prop="frozenCost" label="冻结成本" align="center"></el-table-column>
                        <el-table-column prop="shopProfit" label="店铺利润" align="center"></el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="EditSub">提交</el-button>
                    <el-button type="danger" @click="EditDel">删除</el-button>
                    <el-button type="primary" @click="EditSave">保存</el-button>
                </span>
            </el-dialog>

            <el-dialog title="薪资结算" :visible.sync="settlement_edit1" width="50%">
                <div>
                    <span>用户名：{{valData.userName}}</span>
                    <span style="margin-left:40px;">薪资月份：{{valData.salaryMonth}}</span>
                    <span style="margin-left:40px;">提成结算时间：{{valData.cycle}}</span>
                </div>
                <!-- <div style="margin-top:15px;">
                    <el-table :data="valData.userProfitList" border style="width: 100%">
                        <el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
                        <el-table-column align="center" prop="sellerName" label="店铺名"></el-table-column>
                        <el-table-column align="center" prop="totalProfit" label="利润"></el-table-column>
                        <el-table-column align="center" prop="openRefund" label="未结退款"></el-table-column>
                        <el-table-column align="center" prop="finalProfit" label="最终利润"></el-table-column>
                    </el-table>
                </div> -->

                <div style="margin-top:15px;">
                    <label>结算提成：</label>
                    <span>{{wage1.commission}}</span>

                </div>

                <div style="margin-top:15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" class="table-box wage-table">
                        <tbody>
                            <tr>
                                <template v-for="(h, index) in wageFields">
                                    <th v-if="h.children" :key="'group-' + index" :colspan="h.children.length"
                                        class="group-th">{{ h.label }}</th>
                                    <th v-else :key="'single-' + index" rowspan="2" class="single-th">{{ h.label }}</th>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(h, index) in wageFields">
                                    <template v-if="h.children">
                                        <th v-for="child in h.children" :key="child.prop" class="child-th">{{
                                            child.label }}</th>
                                    </template>
                                </template>
                            </tr>
                            <tr class="input-row">
                                <template v-for="(h, index) in wageFields">
                                    <template v-if="h.children">
                                        <td v-for="child in h.children" :key="child.prop">
                                            <el-input v-model="wage1[child.prop]" size="small"
                                                @focus="setActiveField1(child.prop)"></el-input>
                                        </td>
                                    </template>
                                    <td v-else :key="'td-' + h.prop">
                                        <el-input v-model="wage1[h.prop]" size="small"
                                            @focus="setActiveField1(h.prop)"></el-input>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style="margin-top:15px;">
                    <label style="line-height:50px;">备注</label>
                    <el-input type="textarea" :rows="3" v-model="wage1.remarks" disabled></el-input>
                </div>
                <div style="margin-top:15px">
                    <el-table :data="listTable" border style="margin-top:15px">
                        <el-table-column prop="sellerName" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="orderProfit" label="订单利润" align="center"></el-table-column>
                        <el-table-column prop="shopRent" label="店铺租金" align="center"></el-table-column>
                        <el-table-column prop="orderReturnFee" label="订单退款费用" align="center"></el-table-column>
                        <el-table-column prop="redeliveryFee" label="广告费用" align="center"></el-table-column>
                        <el-table-column prop="frozenCost" label="冻结成本" align="center"></el-table-column>
                        <el-table-column prop="shopProfit" label="店铺利润" align="center"></el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer" v-show="isShow" v-if="this.valData.state == 2">
                    <el-button type="primary" @click="through">确认发放</el-button>
                    <el-button type="danger" @click="nothrough">不予通过</el-button>
                </span>
            </el-dialog>

            <div class="page">
                <el-pagination style="margin-right:200px;" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
                    :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "CommissionSettlementDetails",
    data() {
        return {
            str: "",
            tableData: [],
            listTable: [],
            RateList:[],
            RateList1:[],
            loading:false,
            settlement_steps1:false,
            settlement_steps2:false,
            settlement_edit:false,
            settlement_edit1:false,
            isShow:"",

            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,

            staff: [
                {  name: "已发放", value: 3 },
            ],
            month: [
                {  name: "1月", value: 1 },
                {  name: "2月", value: 2 },
                {  name: "3月", value: 3 },
                {  name: "4月", value: 4 },
                {  name: "5月", value: 5 },
                {  name: "6月", value: 6 },
                {  name: "7月", value: 7 },
                {  name: "8月", value: 8 },
                {  name: "9月", value: 9 },
                {  name: "10月", value: 10 },
                {  name: "11月", value: 11 },
                {  name: "12月", value: 12 },
            ],
            userList:[],
            ruleForm: {
                type: "", //选择状态
                starttime: "", //开始时间
                endtime: "", //结束时间
                input: "",//搜索框
                salaryMonth:""//月份
            },
            Setform: {
                starttime: "", //开始时间
                endtime: "", //结束时间
                salaryMonth:"",//月份
                settlementTime:"",//结算日
                uesr:""//用户
            },
            pickerOptions: {
                shortcuts: [{
                text: '本月',
                onClick: (picker) => {
                    const date = new Date()
                    picker.$emit('pick', date);
                    this.calculationDate()
                }
                }, {
                text: '上一月',
                onClick: (picker) => {
                    const date = new Date();
                    picker.$emit('pick', date);
                    this.calculationDate(-1)
                }
                }, {
                text: '上两月',
                onClick: (picker) => {
                    const date = new Date();
                    picker.$emit('pick', date);
                    this.calculationDate(-2)
                }
                }, {
                text: '上三月',
                onClick: (picker) => {
                    const date = new Date();
                    picker.$emit('pick', date);
                    this.calculationDate(-3)
                }
                }]
            },
            contentList:"",
            wage:{
                basicWage:"",//基本工资
                jobsWage:"",//岗位津贴
                perfectAttendanceAward:"",//全勤奖
                incentiveBonus:"",//激励奖金
                groupCommission:"",//小组提成
                supervisorCommission:"",//提成
                otherSubsidies:"",//其他补贴
                financialReimbursement:"",//财务报销
                reissue:"",//补发
                operationalDeduction:"",//运营扣款
                attendanceDeduction:"",//考勤扣款
                otherDeduction:"",//其他扣款

                commission:"",//结算提成
                remarks:"",//备注
            },
            wage1:{
                basicWage:"",//基本工资
                jobsWage:"",//岗位津贴
                perfectAttendanceAward:"",//全勤奖
                incentiveBonus:"",//激励奖金
                groupCommission:"",//小组提成
                supervisorCommission:"",//提成
                otherSubsidies:"",//其他补贴
                financialReimbursement:"",//财务报销
                reissue:"",//补发
                operationalDeduction:"",//运营扣款
                attendanceDeduction:"",//考勤扣款
                otherDeduction:"",//其他扣款

                commission:"",//结算提成
                remarks:"",//备注
            },
            valData:"",
            wageFields: [
                {
                    label: "底薪", children: [
                        { label: "基本工资", prop: "basicWage" },
                        { label: "工龄工资", prop: "seniorityPay" },
                        { label: "岗位工资", prop: "financialReimbursement" },
                        { label: "学历津贴", prop: "incentiveBonus" },
                    ]
                },
                { label: "提成", prop: "supervisorCommission" },
                { label: "小组提成", prop: "groupCommission" },
                {
                    label: "补助", children: [
                        { label: "试岗补助", prop: "trialPeriodAllowance" },
                        { label: "培训补助", prop: "trainingAllowance" },
                        { label: "TUB", prop: "tub" },
                        { label: "其他补助", prop: "otherAllowances" },
                    ]
                },
                { label: "全勤奖", prop: "perfectAttendanceAward" },
                { label: "奖励", prop: "otherSubsidies" },

                { label: "补发", prop: "reissue" },

                { label: "运营扣款", prop: "operationalDeduction" },
                { label: "考勤扣款", prop: "attendanceDeduction" },
                { label: "职工保险代缴扣款", prop: "otherDeduction" }
            ],
        };
    },
    mounted() {},
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.calculationDate(-3)
        this.exchangeRate();
        this.search();
    },
    methods: {
        open(){
            this.settlement_steps1 = true
            this.user()
            this.EditRateList()
        },
        user(){
            var obj = {companyId:this.str.company_id}
            ajaxPost(Baseurl + "userControllers/selectUserListByCompanyId",obj).then(res => {
                if(res.data.code == 200){
                    this.userList = res.data.data
                }
          });
        },
        EditRateList(){
            ajaxPost(Baseurl + "rateController/getAllRate1").then(res => {
                if(res.data.code == 200){
                    this.RateList1 = res.data.data
                }
          });
        },
        exchangeRate(){
          ajaxPost(Baseurl + "rateController/getAllRate").then(res => {
                if(res.data.code == 200){
                    this.RateList = res.data.data
                }
          });
        },
        searchForm(){
            this.currentPage = 1
            this.search()
        },
        search() {
            var obj = {
                companyId:this.str.company_id,
                startTime1: this.ruleForm.starttime,
                endTime1: this.ruleForm.endtime,
                searchStr: this.ruleForm.input,
                state: 3,
                salaryMonth:this.ruleForm.salaryMonth,
                page: this.currentPage,
                size: this.size,
                signRid:this.str.rid
            };
            ajaxPost(Baseurl + "payrollController/selectPayrollList",obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                }
                this.loading = false;
            });
        },
        searchReset() {
            this.currentPage = 1
            this.ruleForm.type = "";
            this.ruleForm.starttime = "";
            this.ruleForm.endtime = "";
            this.ruleForm.input = "";
            this.ruleForm.salaryMonth = "";
            this.search();
        },
        Add(){
            if(this.Setform.salaryMonth == ""){
                this.$message.error("请选择月份")
            }else if(this.Setform.user == ""){
                this.$message.error("请选择用户")
            }else if(this.Setform.settlementTime == ""){
                this.$message.error("请填写结算日期")
            }else{
                var obj = {
                    uid:this.Setform.user,
                    companyId:this.str.company_id,
                    startTime:this.Setform.starttime,
                    endTime:this.Setform.endtime,
                    rateList:this.RateList1,
                    number:this.Setform.settlementTime,
                    month:this.Setform.salaryMonth
                };
                ajaxPost(Baseurl + "payrollController/getSellerTotalPerformanceByUid",obj).then(res => {
                    if(res.data.code == 200){
                        this.contentList = res.data.data
                        this.settlement_steps2 = true
                    }else{
                        this.$message.error(res.data.data)
                    }
                });
            }
            
        },
        Save(){
            if(this.wage.commission == ""){
                this.$message.error("结算提成不能为空！")
            }else if(this.wage.basicWage == ""){
                this.$message.error("基本工资不能为空！")
            }else if(this.wage.perfectAttendanceAward == ""){
                this.$message.error("全勤奖不能为空！")
            }else if(this.wage.incentiveBonus == ""){
                this.$message.error("激励奖金不能为空！")
            }else if(this.wage.jobsWage == ""){
                this.$message.error("岗位津贴不能为空！")
            }else if(this.wage.groupCommission == ""){
                this.$message.error("小组提成不能为空！")
            }else if(this.wage.supervisorCommission == ""){
                this.$message.error("提成不能为空！")
            }else if(this.wage.otherSubsidies == ""){
                this.$message.error("其他补贴不能为空！")
            }else if(this.wage.financialReimbursement == ""){
                this.$message.error("财务报销不能为空！")
            }else if(this.wage.reissue == ""){
                this.$message.error("补发不能为空！")
            }else if(this.wage.operationalDeduction == ""){
                this.$message.error("运营扣款不能为空！")
            }else if(this.wage.attendanceDeduction == ""){
                this.$message.error("考勤扣款不能为空！")
            }else if(this.wage.otherDeduction == ""){
                this.$message.error("其他扣款不能为空！")
            }
            else{
                var obj = {
                    uid:this.Setform.user,
                    companyId:this.str.company_id,
                    startTime:this.Setform.starttime,
                    endTime:this.Setform.endtime,
                    salaryMonth:this.Setform.salaryMonth,

                    basicWage:this.wage.basicWage,
                    jobsWage:this.wage.jobsWage,
                    perfectAttendanceAward:this.wage.perfectAttendanceAward,
                    incentiveBonus:this.wage.incentiveBonus,
                    groupCommission:this.wage.groupCommission,
                    supervisorCommission:this.wage.supervisorCommission,
                    otherSubsidies:this.wage.otherSubsidies,
                    financialReimbursement:this.wage.financialReimbursement,
                    reissue:this.wage.reissue,
                    operationalDeduction:this.wage.operationalDeduction,
                    attendanceDeduction:this.wage.attendanceDeduction,
                    otherDeduction:this.wage.otherDeduction,

                    commission:this.wage.commission,
                    remarks:this.wage.remarks,
                    sellerList:this.contentList.sellerList
                };
                ajaxPost(Baseurl + "payrollController/insertPayrollInfo",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.search();
                    }else{
                        this.$message.error(res.data.data)
                    }
                    this.Setform.salaryMonth = ""
                    this.Setform.user = ""
                    this.Setform.settlementTime = ""

                    this.wage.commission = ""
                    this.wage.remarks = ""

                    this.wage.basicWage = ""
                    this.wage.jobsWage = ""
                    this.wage.perfectAttendanceAward = ""
                    this.wage.incentiveBonus = ""
                    this.wage.groupCommission = ""
                    this.wage.supervisorCommission = ""
                    this.wage.otherSubsidies = ""
                    this.wage.financialReimbursement = ""
                    this.wage.reissue = ""
                    this.wage.operationalDeduction = ""
                    this.wage.attendanceDeduction = ""
                    this.wage.otherDeduction = ""

                    this.settlement_steps2 = false
                });
            }
                
        },
        //编辑
        Edit(val){
            console.log(val)
            if(this.str.system == 1||this.str.superDepartmentName == '财务部'){
                this.isShow = true
            }else{
                this.isShow = false
            }

            if(val.state == 1||val.state == 4){
                this.settlement_edit = true
            }else{
                this.settlement_edit1 = true
            }
            
            this.valData = val
            this.listTable = val.commissionList
            const obj = { ...this.wage1, ...val };
            this.$set(this, "wage1", obj);
        },
        //编辑保存
        EditSave(){
            var obj = {
                    id:this.valData.id,

                    basicWage:this.wage1.basicWage,
                    jobsWage:this.wage1.jobsWage,
                    perfectAttendanceAward:this.wage1.perfectAttendanceAward,
                    incentiveBonus:this.wage1.incentiveBonus,
                    groupCommission:this.wage1.groupCommission,
                    supervisorCommission:this.wage1.supervisorCommission,
                    otherSubsidies:this.wage1.otherSubsidies,
                    financialReimbursement:this.wage1.financialReimbursement,
                    reissue:this.wage1.reissue,
                    operationalDeduction:this.wage1.operationalDeduction,
                    attendanceDeduction:this.wage1.attendanceDeduction,
                    otherDeduction:this.wage1.otherDeduction,

                    commission:this.wage1.commission,
                    remarks:this.wage1.remarks,
            };
                ajaxPost(Baseurl + "payrollController/updatePayrollInfo",obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.search();
                    }else{
                        this.$message.error(res.data.data)
                    }
                    this.settlement_edit = false
                });
        },
        //编辑删除
        EditDel(){
            this.$confirm('是否删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var obj ={
                    id:this.valData.id,
                    state:0
                }
                ajaxPost(Baseurl + "payrollController/deletePayrollInfo",obj).then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.search();
                        }else{
                            this.$message.error(res.data.data)
                        }
                        this.settlement_edit = false
                });
            })
            
        },
        //编辑提交
        EditSub(){
            this.$confirm('是否提交？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var obj ={
                    id:this.valData.id,
                    signRid:this.str.rid,
                    endTime:this.valData.endTime,
                    uid:this.valData.uid,
                    companyId:this.str.company_id
                }
                ajaxPost(Baseurl + "payrollController/submitPayrollInfo",obj).then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.search();
                        }else{
                            this.$message.error(res.data.data)
                        }
                        this.settlement_edit = false
                });
            })
        },
        through(){
            this.$confirm('是否确认发放', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var obj = {
                    state:3,
                    signRid:this.str.rid,
                    id:this.valData.id,
                    endTime:this.valData.endTime,
                    uid:this.valData.uid,
                    companyId:this.str.company_id
                }
                ajaxPost(Baseurl + "payrollController/reviewPayrollInfo",obj).then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: '发放成功',
                                type: 'success'
                            });
                            this.search();
                        }else{
                            this.$message.error(res.data.data)
                        }
                        this.settlement_edit1 = false
                });
            })
        },
        nothrough(){
            this.$confirm('是否不予通过', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var obj = {
                    state:4,
                    signRid:this.str.rid,
                    id:this.valData.id,
                    endTime:this.valData.endTime,
                    uid:this.valData.uid,
                    companyId:this.str.company_id
                }
                ajaxPost(Baseurl + "payrollController/reviewPayrollInfo",obj).then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: '不予通过',
                                type: 'success'
                            });
                            this.search();
                        }else{
                            this.$message.error(res.data.data)
                        }
                        this.settlement_edit1 = false
                });
            })
            
        },
        calculationDate(type = 0) {
            const date = new Date()
            const year = date.getFullYear()
            const month = date.getMonth() + 1
            const day = date.getDay()
            // this.Setform.starttime = `${year}-${month + type}-01 00:00:00`
            // console.log(this.Setform.starttime)

            const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
            const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
            const prevMonth1 = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}`

            this.Setform.starttime = `${prevMonth1}-01 00:00:00`
            console.log(this.Setform.starttime)
            this.Setform.endtime = `${prevMonth} 23:59:59`
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        }
    }
};
</script>

<style lang="scss">
.CommissionSettlementDetails {
    width: 98%;
    margin-bottom: 50px;
    overflow: hidden;
    .CommissionSettlementDetails-content {
        margin-top: 20px;
        .el-form-item {
            overflow: hidden;
            width: 20%;
            margin-bottom: 18px;
            float: left;
        }
        // .searchInput .el-form-item__content{
        //     margin-left: 0px!important;
        // }
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
        .paging {
            width: 40%;
            margin: 20px auto;
        }
        .table-box{
          border-collapse: collapse;
        }
        .RoteName{
          color: #909399!important;
          font-size: 16px!important;
          font-weight: bold;
        }
        .table-box th{
              text-align: center;
              line-height: 36px;
              border: 1px solid #ebeef5;
              color: #909399;
              font-size: 14px;
        }
        .table-box td{
              text-align: center;
              line-height: 36px;
              border: 1px solid #ebeef5;
              color: #909399;
              font-size: 14px;
              width: 8%;
        }
        .page {
            position: fixed;
            width: 100%;
            bottom: 0;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
        }
    }
}
</style>
